
document.addEventListener("DOMContentLoaded", function () {
    const App = window.WatchlistApp;
    if (!App || !App.Utils || !App.State || !App.Manager || !App.Table || !App.Summary) {
        console.error("WatchlistApp modules not loaded correctly in edit-watchlist.js.");
        return;
    }

    const { Utils, State, Manager, Table, Summary, CsvParser } = App;

    const watchlistBtn = document.getElementById('watchlist-btn');
    const editWatchlistBtn = document.querySelector('.edit-watchlist-btn');
    const editWatchlistOverlay = document.getElementById('edit-watchlist-overlay');
    const saveCloseBtn = editWatchlistOverlay?.querySelector('.save-close-btn');
    const cancelEditBtn = editWatchlistOverlay?.querySelector('.cancel-edit-btn');
    const closeOverlayBtn = editWatchlistOverlay?.querySelector('.close-overlay-btn');
    const overlayTableContainer = editWatchlistOverlay?.querySelector('.overlay-table-container');

    const importCsvBtn = document.querySelector('.import-csv-btn');
    const importCsvInput = document.getElementById('import-csv-input');

    let originalStateSnapshot = null;
    let hasUnsavedChanges = false;
    let csvCurrentImportTickers = new Set();

    function syncMainBlockOverlay() {
        const isWatchlistMode = document.body.classList.contains('watchlist-mode');
        if (!isWatchlistMode) return;

        const hasWatchlists = State.allWatchlists && State.allWatchlists.length > 0;
        const overlay = document.getElementById('watchlist-empty-overlay');

        if (hasWatchlists && overlay) {
            Manager.hideEmptyWatchlistOverlay();
            Manager.enterWatchlistMode(false);
        } else if (!hasWatchlists && !overlay) {
            Manager.showEmptyWatchlistOverlay();
        }
    }

    function captureStateSnapshot() {
        if (!State.currentWatchlistId) return;

        const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
        if (!currentWl) return;

        originalStateSnapshot = {
            watchlistId: State.currentWatchlistId,
            watchlist: JSON.parse(JSON.stringify(currentWl)),
            data: JSON.parse(JSON.stringify(State.currentWatchlistData || []))
        };
        hasUnsavedChanges = false;
    }

    function restoreStateSnapshot() {
        if (!originalStateSnapshot) return;

        const wlIndex = State.allWatchlists.findIndex(w => w.id === originalStateSnapshot.watchlistId);
        if (wlIndex !== -1) {
            State.allWatchlists[wlIndex] = JSON.parse(JSON.stringify(originalStateSnapshot.watchlist));
        }
        State.currentWatchlistData = JSON.parse(JSON.stringify(originalStateSnapshot.data));
        State.setCurrentWatchlistStockCount(State.currentWatchlistData.length);

        const overlayLabel = document.getElementById('overlay-watchlist-selector-label');
        if (overlayLabel) overlayLabel.textContent = window.WatchlistApp.Utils.truncateName(originalStateSnapshot.watchlist.name, 20);

        const tableContainer = document.querySelector('.watchlist-table-container');
        if (tableContainer && tableContainer.classList.contains('active')) {
             Table.renderWatchlistTable(tableContainer);
        }

        hasUnsavedChanges = false;
        originalStateSnapshot = null;
    }

    function addTickersLocally(tickersWithData) {
        
        if (!State.currentWatchlistId) return;
        
        const wlIndex = State.allWatchlists.findIndex(w => w.id === State.currentWatchlistId);
        if (wlIndex === -1) return;
        
        const localWatchlist = State.allWatchlists[wlIndex];
        if (!localWatchlist.holdings) localWatchlist.holdings = {};
        if (!localWatchlist.tickers) localWatchlist.tickers = [];

        tickersWithData.forEach(item => {
            localWatchlist.holdings[item.ticker] = {
                quantity: item.quantity,
                price: item.price,
                date_added: new Date().toISOString()
            };
            
            if (!localWatchlist.tickers.includes(item.ticker)) {
                localWatchlist.tickers.push(item.ticker);
            }
        });
        if (!State.currentWatchlistData) State.currentWatchlistData = [];
        if (!Array.isArray(State.currentWatchlistData)) State.currentWatchlistData = Object.values(State.currentWatchlistData);

        tickersWithData.forEach(item => {
             let existing = State.currentWatchlistData.find(s => s.ticker === item.ticker);
             if (!existing) {
                 existing = {
                     ticker: item.ticker,
                     company_name: item.companyName || item.ticker,
                     price: item.price || 0,
                     todaysChangePerc: 0,
                     todaysChange: 0,
                     totalChangePercent: 0,
                     totalChangeDollar: 0,
                     tickerDetails: { name: item.companyName || item.ticker }
                 };
                 State.currentWatchlistData.push(existing);
             }
             
             existing.quantity = item.quantity;
             existing.price = item.price;
        });

        State.setCurrentWatchlistStockCount(State.currentWatchlistData.length);
        hasUnsavedChanges = true;
        
        if (overlayTableContainer) {
            Table.renderWatchlistTable(overlayTableContainer, true);
        }
        updateStockCounter();
    }

    function removeTickersLocally(tickers) {
        if (!State.currentWatchlistId) return;
        const wlIndex = State.allWatchlists.findIndex(w => w.id === State.currentWatchlistId);
        if (wlIndex === -1) return;

        const localWatchlist = State.allWatchlists[wlIndex];

        if (localWatchlist.tickers) {
            localWatchlist.tickers = localWatchlist.tickers.filter(t => !tickers.includes(t));
        }
        if (localWatchlist.holdings) {
            tickers.forEach(t => delete localWatchlist.holdings[t]);
        }

        if (State.currentWatchlistData) {
            if (!Array.isArray(State.currentWatchlistData)) {
                 State.currentWatchlistData = Object.values(State.currentWatchlistData);
            }
            const initialLen = State.currentWatchlistData.length;
            State.currentWatchlistData = State.currentWatchlistData.filter(s => !tickers.includes(s.ticker));
        }

        State.setCurrentWatchlistStockCount(State.currentWatchlistData ? State.currentWatchlistData.length : 0);
        hasUnsavedChanges = true;

        if (overlayTableContainer) {
            Table.renderWatchlistTable(overlayTableContainer, true);
        }
        updateStockCounter();
    }

    if (importCsvBtn && importCsvInput) {
        importCsvBtn.addEventListener('click', () => {
            const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
            const count = State.getCurrentWatchlistStockCount();

            if (!isPremium && count >= 50) {
                 if (App.Popup && App.Popup.showPremiumLimitPopup) {
                     App.Popup.showPremiumLimitPopup(
                         "Unlimited stocks in watchlist are coming soon!",
                         "Adding more than 50 assets is a Pro feature currently in development."
                     );
                 }
                 return;
            }
            importCsvInput.click();

            if (window.gtag) gtag('event', `Desktop_TopNav_Watchlist_ImportCSV`);
        });

        importCsvInput.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (file) processCsvFile(file);
            e.target.value = '';
        });

        importCsvBtn.addEventListener('dragover', (e) => { e.preventDefault(); importCsvBtn.style.opacity = '0.7'; });
        importCsvBtn.addEventListener('dragleave', (e) => { e.preventDefault(); importCsvBtn.style.opacity = '1'; });
        importCsvBtn.addEventListener('drop', (e) => {
            e.preventDefault();
            importCsvBtn.style.opacity = '1';
            if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                 if (e.dataTransfer.files[0].name.endsWith('.csv')) processCsvFile(e.dataTransfer.files[0]);
            }
        });
    }

    function setupImportCsvTooltip() {
        if (!importCsvBtn || !editWatchlistOverlay) return;

        const tooltip = document.createElement('div');
        tooltip.className = 'import-csv-tooltip hover-pop-up';
        Object.assign(tooltip.style, {
            position: 'absolute',
            width: '280px',
            background: 'var(--color-bg-page)',
            border: '1px solid var(--color-border-popup)',
            borderRadius: '8px',
            padding: '12px',
            display: 'none',
            pointerEvents: 'none',
            zIndex: '10001',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            color: 'var(--color-text-primary)',
            fontSize: '13px',
            lineHeight: '1.5'
        });

        tooltip.innerHTML = `
            <div style="margin-bottom: 8px;">1) Go to your brokerage web site</div>
            <div style="margin-bottom: 8px;">2) Export a .CSV file containing your stock positions and save it locally on your computer</div>
            <div>3) Import that .CSV file into StockStorm to load your stock symbols, number of shares, and cost basis</div>
        `;

        editWatchlistOverlay.appendChild(tooltip);

        importCsvBtn.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
            const btnRect = importCsvBtn.getBoundingClientRect();
            const overlayRect = editWatchlistOverlay.getBoundingClientRect();

            let left = btnRect.left - overlayRect.left;
            let top = btnRect.bottom - overlayRect.top + 10;

            if (left + tooltip.offsetWidth > overlayRect.width) {
                left = overlayRect.width - tooltip.offsetWidth - 20;
            }

            tooltip.style.left = `${left}px`;
            tooltip.style.top = `${top}px`;
        });

        importCsvBtn.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
        });
    }

    setupImportCsvTooltip();

    async function processCsvFile(file) {
        if (!App.CsvParser) return;
        try {
            const tickersToAdd = await App.CsvParser.parse(file);
            if (tickersToAdd.length > 0 && State.currentWatchlistId) {
                const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
                const currentStockCount = State.getCurrentWatchlistStockCount();
                const regexValidTickers = tickersToAdd.filter(t => /^[A-Z.-]+$/.test(t.ticker));

                if (!isPremium && (currentStockCount + regexValidTickers.length) > 50) {
                     if (App.Popup && App.Popup.showPremiumLimitPopup) {
                         App.Popup.showPremiumLimitPopup(
                             "Unlimited stocks in watchlist are coming soon!",
                             "Adding more than 50 assets is a Pro feature currently in development."
                         );
                     }
                     return;
                }

                if (regexValidTickers.length > 0) {
                     addTickersLocally(regexValidTickers);
                     regexValidTickers.forEach(t => csvCurrentImportTickers.add(t.ticker));
                }
            }
        } catch (err) {
            console.error("Error parsing CSV:", err);
        }
    }

    if (editWatchlistBtn) {
        editWatchlistBtn.addEventListener('click', function () {
            if (window.consentGiven === false) {
                if (window.AuthUI && window.AuthUI.showMessage) {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                }
                return;
            }
            if (editWatchlistOverlay) {
                captureStateSnapshot();
                
                editWatchlistOverlay.classList.add('show');

                const hasWatchlists = State.allWatchlists && State.allWatchlists.length > 0;

                if (!hasWatchlists) {
                    const overlayContent = editWatchlistOverlay.querySelector('.overlay-content');
                    const overlayControls = editWatchlistOverlay.querySelector('.overlay-controls');
                    const overlayActions = editWatchlistOverlay.querySelector('.overlay-actions');
                    
                    if (overlayControls) overlayControls.style.display = 'none';
                    if (overlayTableContainer) overlayTableContainer.style.display = 'none';
                    if (overlayActions) overlayActions.style.display = 'none';
                    if (closeOverlayBtn) closeOverlayBtn.style.display = 'flex';

                    let placeholder = editWatchlistOverlay.querySelector('.edit-overlay-empty-placeholder');
                    if (!placeholder) {
                        placeholder = document.createElement('div');
                        placeholder.className = 'edit-overlay-empty-placeholder';
                        placeholder.style.cssText = 'display:flex;align-items:center;justify-content:center;flex:1;';
                        
                        const createBtn = document.createElement('button');
                        createBtn.className = 'watchlist-empty-action-btn';
                        createBtn.textContent = 'Create a watchlist';
                        createBtn.addEventListener('click', function () {
                            const App = window.WatchlistApp;
                            if (App.Popup && App.Popup.showInputPopup) {
                                const uname = Utils.getCurrentUsername ? Utils.getCurrentUsername() : '';
                                const defaultName = uname ? `${uname}'s watchlist` : 'Watchlist';
                                App.Popup.showInputPopup('Create Watchlist', defaultName, 'Watchlist Name', 'Create', async (newName) => {
                                    if (newName) {
                                        await App.Manager.createWatchlist(newName, true);
                                        
                                        const created = State.allWatchlists.find(w => w.name === newName);
                                        if (created) {
                                            State.currentWatchlistId = created.id;
                                            State.currentWatchlistData = [];
                                        }
                                        
                                        placeholder.remove();
                                        if (overlayControls) overlayControls.style.display = '';
                                        if (overlayTableContainer) overlayTableContainer.style.display = '';
                                        if (overlayActions) overlayActions.style.display = '';
                                        
                                        Table.renderWatchlistTable(overlayTableContainer, true);
                                        syncOverlayDropdown();
                                        updateStockCounter();
                                        captureStateSnapshot();
                                    }
                                }, { restrictUnicode: true });
                            }
                        });
                        
                        placeholder.appendChild(createBtn);
                        overlayContent.appendChild(placeholder);
                    }
                } else {
                    if (closeOverlayBtn) closeOverlayBtn.style.display = 'none';
                    const stalePlaceholder = editWatchlistOverlay.querySelector('.edit-overlay-empty-placeholder');
                    if (stalePlaceholder) stalePlaceholder.remove();
                    const overlayControls = editWatchlistOverlay.querySelector('.overlay-controls');
                    const overlayActions = editWatchlistOverlay.querySelector('.overlay-actions');
                    if (overlayControls) overlayControls.style.display = '';
                    if (overlayTableContainer) overlayTableContainer.style.display = '';
                    if (overlayActions) overlayActions.style.display = '';

                    if (!State.currentWatchlistId) {
                        State.currentWatchlistData = [];
                    }
                    Table.renderWatchlistTable(overlayTableContainer, true);
                    syncOverlayDropdown();
                    updateStockCounter();
                }

                if (window.gtag) gtag('event', `Desktop_TopNav_WatchlistEdit`);
            }
        });
    }

    if (saveCloseBtn) {
        saveCloseBtn.addEventListener('click', async function () {
            if (editWatchlistOverlay) {
                
                if (hasUnsavedChanges && State.currentWatchlistId) {
                    saveCloseBtn.textContent = 'Saving...';
                    saveCloseBtn.disabled = true;

                    if (window.gtag) gtag('event', `Desktop_TopNav_Watchlist_Save`);

                    try {
                         const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
                         if (currentWl) {
                             await WatchlistAPIManager.instance.updateWatchlist(
                                 State.currentWatchlistId,
                                 currentWl.name,
                                 currentWl.tickers,
                                 currentWl.holdings
                             );
                             
                             if (Manager.populateWatchlistDropdown) {
                                 Manager.populateWatchlistDropdown(State.allWatchlists, State.currentUserId, false);
                             }
                         }
                     } catch(e) {
                         console.error('Failed to save watchlist:', e);
                         saveCloseBtn.textContent = 'Save';
                         saveCloseBtn.disabled = false;
                         return;
                     }
                }

                editWatchlistOverlay.classList.remove('show');
                saveCloseBtn.textContent = 'Save';
                saveCloseBtn.disabled = false;
                hasUnsavedChanges = false;
                originalStateSnapshot = null;

                syncMainBlockOverlay();

                const isWatchlistMode = document.body.classList.contains('watchlist-mode');
                if (State.currentWatchlistId && (isWatchlistMode || csvCurrentImportTickers.size > 0)) {
                     await Manager.loadWatchlistData(State.currentUserId, State.currentWatchlistId, [], null, isWatchlistMode);
                     if (csvCurrentImportTickers.size > 0 && State.currentWatchlistData) {
                        const loadedTickers = new Set(State.currentWatchlistData.map(s => s.ticker));
                        
                        const missingTickers = [];
                        csvCurrentImportTickers.forEach(ticker => {
                            if (!loadedTickers.has(ticker)) {
                                missingTickers.push(ticker);
                            }
                        });
            
                        if (missingTickers.length > 0) {
                             console.warn('[EditWatchlist] Post-save verification found missing tickers:', missingTickers);
                             if (App.Popup && App.Popup.showNotificationPopup) {
                                  const displayList = missingTickers.length > 5 
                                     ? missingTickers.slice(0, 5).join(', ') + `... (+${missingTickers.length - 5} more)`
                                     : missingTickers.join(', ');
                                  
                                  App.Popup.showNotificationPopup(
                                      'Tickers Not Added',
                                      `The following ${missingTickers.length} ticker(s) were not added (likely unsupported):<br><b>${displayList}</b>`
                                  );
                             }
                        }
                        
                        csvCurrentImportTickers.clear();
                    }
                }
            }
        });
    }

    if (cancelEditBtn) {
        cancelEditBtn.addEventListener('click', function () {
             if (hasUnsavedChanges && App.Popup && App.Popup.showConfirmationPopup) {
                 App.Popup.showConfirmationPopup(
                     'Discard changes?',
                     'You have unsaved changes.<br>Are you sure you want to discard them?',
                     'Discard Changes',
                     () => {
                         restoreStateSnapshot();
                         if (editWatchlistOverlay) editWatchlistOverlay.classList.remove('show');
                         syncMainBlockOverlay();
                     },
                     'Continue Editing',
                     null,
                     'btn-tertiary-negative',
                     'cancel-popup-btn'
                 );
             } else {
                 if (hasUnsavedChanges) restoreStateSnapshot();
                 if (editWatchlistOverlay) editWatchlistOverlay.classList.remove('show');
                 syncMainBlockOverlay();
             }
        });
    }

    if (closeOverlayBtn) {
        closeOverlayBtn.addEventListener('click', function () {
            if (editWatchlistOverlay) {
                editWatchlistOverlay.classList.remove('show');
                hasUnsavedChanges = false;
                originalStateSnapshot = null;
                syncMainBlockOverlay();
            }
        });
    }

    const overlayAddUnitBtn = editWatchlistOverlay?.querySelector('.add-unit-btn');
    if (overlayAddUnitBtn) {
        overlayAddUnitBtn.addEventListener('click', function () {
            if (!State.currentWatchlistId) {
                return;
            }

            const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
            const count = State.getCurrentWatchlistStockCount();

            if (!isPremium && count >= 50) {
                if (App.Popup && App.Popup.showPremiumLimitPopup) {
                    App.Popup.showPremiumLimitPopup(
                        "Unlimited stocks in watchlist are coming soon!",
                        "Adding more than 50 assets is a Pro feature currently in development."
                    );
                }
                return;
            }

            if (App.Popup && App.Popup.showAddUnitPopup) {
                App.Popup.showAddUnitPopup({
                    onAdd: async (data) => {
                        addTickersLocally([data]);
                        return true;
                    }
                });

                if (window.gtag) gtag('event', `Desktop_TopNav_Watchlist_AddUnit`);
            }
        });
    }

    const overlayRemoveUnitBtn = editWatchlistOverlay?.querySelector('.remove-unit-btn');
    if (overlayRemoveUnitBtn) {
        overlayRemoveUnitBtn.addEventListener('click', function () {
            const selectedTickers = [];
            const checkboxes = overlayTableContainer?.querySelectorAll('.row-checkbox:checked');
            checkboxes?.forEach(cb => {
                const row = cb.closest('tr');
                const symbol = row.querySelector('.symbol-cell').textContent.trim();
                selectedTickers.push(symbol);
            });

            if (selectedTickers.length > 0) {
                 if (App.Popup && App.Popup.showRemoveConfirmationPopup) {
                     App.Popup.showRemoveConfirmationPopup(selectedTickers.length, async () => {
                         removeTickersLocally(selectedTickers);
                     });
                 } else {
                     removeTickersLocally(selectedTickers);
                 }
                if (window.gtag) gtag('event', `Desktop_TopNav_Watchlist_RemoveUnit`);
            } else {
                 console.warn('Please select stocks to remove.');
            }
        });
    }

    const renameBtn = editWatchlistOverlay?.querySelector('.rename-watchlist-btn');
    if (renameBtn) {
        renameBtn.addEventListener('click', function () {
            if (!State.currentWatchlistId) {
                 if (App.Popup && App.Popup.showInputPopup) {
                    const uname = Utils.getCurrentUsername();
                    const defaultName = uname ? `${uname}'s watchlist` : "Watchlist";
                    App.Popup.showInputPopup('Create Watchlist', defaultName, 'Watchlist Name', 'Create', async (newName) => {
                         try {
                             const res = await WatchlistAPIManager.instance.createWatchlist(newName);
                             if (res) {
                                 await Manager.enterWatchlistMode(); 
                                 syncOverlayDropdown();
                                 captureStateSnapshot();
                             }
                         } catch(e) { console.error(e); }
                   }, { restrictUnicode: true });
                }
                return;
            }

            const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
            const currentName = currentWl ? currentWl.name : (document.getElementById('overlay-watchlist-selector-label')?.textContent || "");
            
            if (App.Popup && App.Popup.showInputPopup) {
                App.Popup.showInputPopup('Rename Watchlist', currentName, 'Watchlist Name', 'Rename', async (newName) => {
                    if (newName && newName !== currentName) {
                        const wList = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
                        if (wList) {
                            wList.name = newName;
                            hasUnsavedChanges = true;
                            
                            const overlayLabel = document.getElementById('overlay-watchlist-selector-label');
                             if (overlayLabel) overlayLabel.textContent = window.WatchlistApp.Utils.truncateName(newName, 20);
                        }
                    }
                }, { restrictUnicode: true });

                if (window.gtag) gtag('event', `Desktop_TopNav_Watchlist_Rename`);
            }
        });
    }
    
    function syncOverlayDropdown() {
        const State = window.WatchlistApp.State;
        const Manager = window.WatchlistApp.Manager;

        const overlayLabel = document.getElementById('overlay-watchlist-selector-label');
        const overlayMenu = document.getElementById('overlay-watchlist-selector-menu');

        if (renameBtn) {
            if (!State.allWatchlists || State.allWatchlists.length === 0 || !State.currentWatchlistId) {
                renameBtn.textContent = 'Create Watchlist';
            } else {
                renameBtn.textContent = 'Rename Watchlist';
            }
        }
        if (overlayLabel) {
            if (!State.allWatchlists || State.allWatchlists.length === 0) {
                 overlayLabel.textContent = 'No Watchlists';
            } else if (State.currentWatchlistId) {
                const current = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
                if (current) overlayLabel.textContent = window.WatchlistApp.Utils.truncateName(current.name, 20);
                else overlayLabel.textContent = 'Select Watchlist';
            } else {
                 overlayLabel.textContent = 'Select Watchlist';
            }
        }

        if (overlayMenu && State.allWatchlists) {
            overlayMenu.innerHTML = '';
            State.allWatchlists.forEach(wl => {
                const item = document.createElement('div');
                item.className = 'dropdown-item';
                if (wl.id === State.currentWatchlistId) item.classList.add('active');
                item.setAttribute('data-value', wl.id);
                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.justifyContent = 'space-between';

                const nameSpan = document.createElement('span');
                nameSpan.textContent = window.WatchlistApp.Utils.truncateName(wl.name, 20);
                nameSpan.style.flexGrow = '1';
                item.appendChild(nameSpan);

                const deleteBtn = document.createElement('img');
                deleteBtn.className = 'delete-watchlist-btn';
                deleteBtn.src = 'desktop_assets/main-block/trash.svg';
                deleteBtn.addEventListener('click', async function (e) {
                    e.stopPropagation();
                    if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showConfirmationPopup) {
                        window.WatchlistApp.Popup.showConfirmationPopup(
                            'Delete Watchlist?',
                            `Are you sure you want to delete "${wl.name}"?<br>This action cannot be undone.`,
                            'Delete',
                            async () => {
                                await Manager.deleteWatchlist(wl.id);
                                syncOverlayDropdown();
                            },
                            'Cancel',
                            null,
                            'btn-tertiary-negative',
                            'cancel-popup-btn'
                        );
                    } else if (confirm(`Delete "${wl.name}"? This action cannot be undone.`)) {
                         await Manager.deleteWatchlist(wl.id);
                         syncOverlayDropdown();
                    }
                });
                item.appendChild(deleteBtn);

                item.addEventListener('click', function (e) {
                    e.stopPropagation();
                    if (hasUnsavedChanges) {
                         if(!confirm("You have unsaved changes. Switch watchlist and discard changes?")) return;
                    }

                    const label = nameSpan.textContent;
                    if (overlayLabel) overlayLabel.textContent = label;
                    
                    Manager.loadWatchlistData(State.currentUserId, wl.id, [], null, document.body.classList.contains('watchlist-mode')).then(() => {
                         captureStateSnapshot();
                         
                         const overlayTableContainer = editWatchlistOverlay.querySelector('.overlay-table-container');
                         if (overlayTableContainer) Table.renderWatchlistTable(overlayTableContainer, true);
                         updateStockCounter();
                    });
                });
                overlayMenu.appendChild(item);
            });
        }
    }

    function updateStockCounter() {
        if (!editWatchlistOverlay) return;
        const header = editWatchlistOverlay.querySelector('.overlay-header');
        if (!header) return;
        let counter = header.querySelector('.stock-counter');
        if (!counter) {
            counter = document.createElement('div');
            counter.className = 'stock-counter';
            header.appendChild(counter);
            counter.style.marginLeft = 'auto'; 
            counter.style.marginRight = '30px';
            counter.style.fontSize = '16px';
            counter.style.color = 'var(--color-text-primary)';
            counter.style.fontWeight = '500';
        }
        const count = State.getCurrentWatchlistStockCount();
        counter.textContent = `${count} / 50`;
    }

    const overlayDropdownBtn = document.getElementById('overlay-watchlist-selector-btn');
    const overlayDropdown = document.getElementById('overlay-watchlist-selector');
    if (overlayDropdownBtn && overlayDropdown) {
        overlayDropdownBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            const State = window.WatchlistApp.State;
            if (!State.allWatchlists || State.allWatchlists.length === 0) {
                return;
            }
            overlayDropdown.classList.toggle('active');
        });
        document.addEventListener('click', function (e) {
            if (overlayDropdown && !overlayDropdown.contains(e.target)) {
                overlayDropdown.classList.remove('active');
            }
        });
    }

     if (watchlistBtn) {
        watchlistBtn.addEventListener('click', async function () {
            if (window.consentGiven === false) {
                if (window.AuthUI && window.AuthUI.showMessage) {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                }
                return;
            }
            if (Manager.checkWatchlistAccess) {
                const access = Manager.checkWatchlistAccess();
                if (!access.allowed) {
                    const message = 'Log in to access watchlist';
                    if (App.Popup && App.Popup.showNotificationPopup) {
                        App.Popup.showNotificationPopup('Watchlist Access', message);
                    }
                    return;
                }
            }
            
            const isInWatchlistMode = document.body.classList.contains('watchlist-mode');
            
            if (!isInWatchlistMode) {
                 if (!State.allWatchlists || State.allWatchlists.length === 0) {
                      const data = await WatchlistAPIManager.instance.getWatchlists();
                      if (data && data.watchlists) {
                           State.allWatchlists = Array.isArray(data.watchlists) ? data.watchlists : (data.watchlists.watchlists || []);
                           State.currentUserId = data.user_id;
                      }
                 }
                 if (State.allWatchlists.length > 0) {
                      State.currentWatchlistId = State.allWatchlists[0].id;
                      await Manager.loadWatchlistData(State.currentUserId, State.currentWatchlistId, [], null, false);
                 } else {
                     State.currentWatchlistId = null;
                     State.currentWatchlistData = [];
                 }
            }

            if (editWatchlistOverlay) {
                captureStateSnapshot();
                editWatchlistOverlay.classList.add('show');

                const hasWatchlists = State.allWatchlists && State.allWatchlists.length > 0;

                if (!hasWatchlists) {
                    const overlayContent = editWatchlistOverlay.querySelector('.overlay-content');
                    const overlayControls = editWatchlistOverlay.querySelector('.overlay-controls');
                    const overlayActions = editWatchlistOverlay.querySelector('.overlay-actions');
                    
                    if (overlayControls) overlayControls.style.display = 'none';
                    if (overlayTableContainer) overlayTableContainer.style.display = 'none';
                    if (overlayActions) overlayActions.style.display = 'none';
                    if (closeOverlayBtn) closeOverlayBtn.style.display = 'flex';

                    let placeholder = editWatchlistOverlay.querySelector('.edit-overlay-empty-placeholder');
                    if (!placeholder) {
                        placeholder = document.createElement('div');
                        placeholder.className = 'edit-overlay-empty-placeholder';
                        placeholder.style.cssText = 'display:flex;align-items:center;justify-content:center;flex:1;';
                        
                        const createBtn = document.createElement('button');
                        createBtn.className = 'watchlist-empty-action-btn';
                        createBtn.textContent = 'Create a watchlist';
                        createBtn.addEventListener('click', function () {
                            if (App.Popup && App.Popup.showInputPopup) {
                                const uname = Utils.getCurrentUsername ? Utils.getCurrentUsername() : '';
                                const defaultName = uname ? `${uname}'s watchlist` : 'Watchlist';
                                App.Popup.showInputPopup('Create Watchlist', defaultName, 'Watchlist Name', 'Create', async (newName) => {
                                    if (newName) {
                                        await Manager.createWatchlist(newName, true);
                                        
                                        const created = State.allWatchlists.find(w => w.name === newName);
                                        if (created) {
                                            State.currentWatchlistId = created.id;
                                            State.currentWatchlistData = [];
                                        }
                                        
                                        placeholder.remove();
                                        if (overlayControls) overlayControls.style.display = '';
                                        if (overlayTableContainer) overlayTableContainer.style.display = '';
                                        if (overlayActions) overlayActions.style.display = '';
                                        
                                        Table.renderWatchlistTable(overlayTableContainer, true);
                                        syncOverlayDropdown();
                                        updateStockCounter();
                                        captureStateSnapshot();
                                    }
                                }, { restrictUnicode: true });
                            }
                        });
                        
                        placeholder.appendChild(createBtn);
                        overlayContent.appendChild(placeholder);
                    }
                } else {
                    if (closeOverlayBtn) closeOverlayBtn.style.display = 'none';
                    const stalePlaceholder = editWatchlistOverlay.querySelector('.edit-overlay-empty-placeholder');
                    if (stalePlaceholder) stalePlaceholder.remove();
                    const overlayControls = editWatchlistOverlay.querySelector('.overlay-controls');
                    const overlayActions = editWatchlistOverlay.querySelector('.overlay-actions');
                    if (overlayControls) overlayControls.style.display = '';
                    if (overlayTableContainer) overlayTableContainer.style.display = '';
                    if (overlayActions) overlayActions.style.display = '';

                    Table.renderWatchlistTable(overlayTableContainer, true);
                    syncOverlayDropdown();
                    updateStockCounter();
                }
                
                if (window.gtag) gtag('event', `Desktop_TopNav_WatchlistEdit`);
            }
        });
    }

    document.body.addEventListener('watchlist-data-loaded', function (e) {
        if (editWatchlistOverlay && editWatchlistOverlay.classList.contains('show')) {
            if (!hasUnsavedChanges) {
                 if (overlayTableContainer) Table.renderWatchlistTable(overlayTableContainer, true);
                 updateStockCounter();
                 captureStateSnapshot();
            }
        }
    });

    if (overlayTableContainer) {
        overlayTableContainer.addEventListener('watchlist-cell-edited', (e) => {
            hasUnsavedChanges = true;
            
            if (e.detail && e.detail.updatePayload) {
                 const pl = e.detail.updatePayload;
                 if (State.currentWatchlistData && Array.isArray(State.currentWatchlistData)) {
                     const item = State.currentWatchlistData.find(s => s.ticker === pl.ticker);
                     if (item) {
                         if (pl.quantity !== undefined) item.quantity = pl.quantity;
                         if (pl.price !== undefined) item.price = pl.price;
                     }
                 }
            }
        });
    }

    document.addEventListener('watchlist:auth-changed', function (e) {
        if (e.detail && e.detail.reason === 'consent_revoked') {
            if (editWatchlistOverlay && editWatchlistOverlay.classList.contains('show')) {
                editWatchlistOverlay.classList.remove('show');
                hasUnsavedChanges = false;
                originalStateSnapshot = null;
                syncMainBlockOverlay();
            }
        }
    });

});
